import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, useMediaQuery } from '@mui/material';
import notFoundImage from './Images/404.png';
import styles from './NotFound.module.css';

const NotFound = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Box className={styles.container}>
      <div className={styles.glowEffect}></div>
      <Box className={styles.content}>
        <div className={styles.imageContainer}>
          <img
            src={notFoundImage}
            alt="404 Error"
            className={styles.errorImage}
          />
          <div className={styles.imageGlow}></div>
        </div>
        <Typography variant={isMobile ? 'h4' : 'h2'} className={styles.title}>
          Lost in Digital Space
        </Typography>
        <Typography variant="body1" className={styles.description}>
          The page you're seeking has either drifted into the cosmos or is 
          temporarily orbiting another dimension. Let's get you back home.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleGoHome}
          className={styles.button}
          sx={{
            mt: 3,
            mb: 2,
            borderRadius: '12px',
            padding: '12px 32px',
            fontSize: isMobile ? '0.9rem' : '1.1rem',
            textTransform: 'none',
            fontWeight: 600,
            letterSpacing: '0.5px'
          }}
        >
          Beam Me Home
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;